/** Interface strings of operators and roles (read through useAccessT). */
export const adminAccessMessages = {
  "admin.denied.access": {
    ru: "Для раздела нужно разрешение operators.read.",
    en: "This section needs the operators.read permission.",
  },
  "admin.access.title": { ru: "Операторы и роли", en: "Operators and roles" },
  "admin.access.views": { ru: "Вид раздела", en: "Section view" },
  "admin.access.tab.operators": { ru: "Операторы", en: "Operators" },
  "admin.access.tab.roles": { ru: "Роли", en: "Roles" },
  "admin.access.pick": {
    ru: "Выберите оператора, чтобы увидеть детали.",
    en: "Pick an operator to see the details.",
  },
  "admin.access.pickRole": {
    ru: "Выберите роль, чтобы увидеть права.",
    en: "Pick a role to see its permissions.",
  },
  "admin.access.loading": { ru: "Загрузка", en: "Loading" },
  "admin.access.failed": {
    ru: "Не удалось загрузить данные доступа.",
    en: "Could not load access data.",
  },
  "admin.access.notFound": {
    ru: "Запись не найдена.",
    en: "Record not found.",
  },
  "admin.access.back": { ru: "Назад", en: "Back" },
  "admin.access.readOnly": {
    ru: "Просмотр без изменений: управлять операторами может только администратор платформы.",
    en: "Read-only: only a platform administrator can manage operators.",
  },
  "admin.access.readOnlyDenied": {
    ru: "Сервер отклонил изменение: у вашей роли нет права operators.manage. Раздел доступен только для чтения.",
    en: "The server refused the change: your role lacks operators.manage. The section is read-only.",
  },
  "admin.access.list.operators": { ru: "Операторы", en: "Operators" },
  "admin.access.list.roles": { ru: "Роли", en: "Roles" },
  "admin.access.empty": { ru: "Операторов пока нет.", en: "No operators yet." },
  "admin.access.operator.add": {
    ru: "Добавить оператора",
    en: "Add operator",
  },
  "admin.access.operator.self": { ru: "вы", en: "you" },
  "admin.access.operator.active": { ru: "Активен", en: "Active" },
  "admin.access.operator.inactive": { ru: "Отключён", en: "Deactivated" },
  "admin.access.operator.noName": { ru: "Без имени", en: "Unnamed" },
  "admin.access.operator.subject": { ru: "Auth0 user_id", en: "Auth0 user_id" },
  "admin.access.operator.linkedUser": {
    ru: "Связанный пользователь",
    en: "Linked user",
  },
  "admin.access.operator.lastSignIn": {
    ru: "Последний вход",
    en: "Last sign-in",
  },
  "admin.access.operator.never": { ru: "не входил", en: "never" },
  "admin.access.operator.sessions": {
    ru: "Активных сессий",
    en: "Active sessions",
  },
  "admin.access.operator.roles": { ru: "Роли", en: "Roles" },
  "admin.access.operator.noRoles": { ru: "Ролей нет.", en: "No roles." },
  "admin.access.operator.permissions": {
    ru: "Эффективные права",
    en: "Effective permissions",
  },
  "admin.access.operator.noPermissions": {
    ru: "Прав нет.",
    en: "No permissions.",
  },
  "admin.access.operator.deactivate": {
    ru: "Отключить оператора",
    en: "Deactivate operator",
  },
  "admin.access.operator.activate": {
    ru: "Включить оператора",
    en: "Reactivate operator",
  },
  "admin.access.operator.auditTrail": {
    ru: "Журнал действий",
    en: "Activity log",
  },
  "admin.access.role.assign": { ru: "Назначить роль", en: "Assign a role" },
  "admin.access.role.assign.placeholder": {
    ru: "Выберите роль",
    en: "Pick a role",
  },
  "admin.access.role.assign.submit": { ru: "Назначить", en: "Assign" },
  "admin.access.role.unassign": { ru: "Снять", en: "Remove" },
  "admin.access.role.notGrantable": {
    ru: "недоступно: у вас нет всех её прав",
    en: "unavailable: you lack some of its permissions",
  },
  "admin.access.role.operators": { ru: "Операторов", en: "Operators" },
  "admin.access.role.permissions": { ru: "Права роли", en: "Role permissions" },
  "admin.access.role.inactive": { ru: "Отключена", en: "Inactive" },
  "admin.access.role.active": { ru: "Активна", en: "Active" },
  "admin.access.role.noPermissions": {
    ru: "У роли нет прав.",
    en: "This role has no permissions.",
  },
  "admin.access.role.name.platform-admin": {
    ru: "Администратор платформы",
    en: "Platform administrator",
  },
  "admin.access.role.name.support-agent": {
    ru: "Агент поддержки",
    en: "Support agent",
  },
  "admin.access.role.name.support-lead": {
    ru: "Руководитель поддержки",
    en: "Support lead",
  },
  "admin.access.role.name.billing-analyst": {
    ru: "Аналитик биллинга",
    en: "Billing analyst",
  },
  "admin.access.permission.admin.access": {
    ru: "Доступ в консоль",
    en: "Console access",
  },
  "admin.access.permission.content.read": {
    ru: "Чтение контента",
    en: "Read content",
  },
  "admin.access.permission.operations.read": {
    ru: "Сводка операций",
    en: "Operations overview",
  },
  "admin.access.permission.billing.refund": {
    ru: "Возвраты платежей",
    en: "Payment refunds",
  },
  "admin.access.permission.users.read": {
    ru: "Просмотр пользователей",
    en: "View users",
  },
  "admin.access.permission.users.billing.read": {
    ru: "Биллинг пользователя",
    en: "User billing",
  },
  "admin.access.permission.users.pii.read": {
    ru: "Персональные данные",
    en: "Personal data",
  },
  "admin.access.permission.observability.trace.read": {
    ru: "Логи и трассы",
    en: "Logs and traces",
  },
  "admin.access.permission.observability.read": {
    ru: "Нагрузка",
    en: "Load",
  },
  "admin.access.permission.assistant.feedback.review": {
    ru: "Разбор фидбэка",
    en: "Feedback review",
  },
  "admin.access.permission.assistant.trace.read": {
    ru: "Инспектор ассистента",
    en: "Assistant inspector",
  },
  "admin.access.permission.model_registry.read": {
    ru: "Модели: просмотр",
    en: "Models: view",
  },
  "admin.access.permission.model_registry.manage": {
    ru: "Модели: управление",
    en: "Models: manage",
  },
  "admin.access.permission.model_registry.manage_remote": {
    ru: "Модели: удалённые провайдеры",
    en: "Models: remote providers",
  },
  "admin.access.permission.billing.prices.read": {
    ru: "Цены: просмотр",
    en: "Prices: view",
  },
  "admin.access.permission.billing.prices.write": {
    ru: "Цены: изменение",
    en: "Prices: edit",
  },
  "admin.access.permission.billing.grants.write": {
    ru: "Ручные начисления",
    en: "Manual grants",
  },
  "admin.access.permission.operators.read": {
    ru: "Операторы: просмотр",
    en: "Operators: view",
  },
  "admin.access.permission.operators.manage": {
    ru: "Операторы: управление",
    en: "Operators: manage",
  },
  "admin.access.permission.audit.read": {
    ru: "Журнал аудита",
    en: "Audit log",
  },
  "admin.access.reason.code": { ru: "Причина", en: "Reason" },
  "admin.access.reason.code.placeholder": {
    ru: "Выберите причину",
    en: "Pick a reason",
  },
  "admin.access.reason.code.onboarding": {
    ru: "Новый сотрудник",
    en: "Onboarding",
  },
  "admin.access.reason.code.offboarding": {
    ru: "Уход сотрудника",
    en: "Offboarding",
  },
  "admin.access.reason.code.role_change": {
    ru: "Смена роли",
    en: "Role change",
  },
  "admin.access.reason.code.access_review": {
    ru: "Пересмотр доступа",
    en: "Access review",
  },
  "admin.access.reason.code.incident": { ru: "Инцидент", en: "Incident" },
  "admin.access.reason.text": { ru: "Комментарий", en: "Comment" },
  "admin.access.reason.counter": { ru: "{n} из {max}", en: "{n} of {max}" },
  "admin.access.reason.confirm": {
    ru: "Подтверждаю изменение доступа",
    en: "I confirm this access change",
  },
  "admin.access.reason.submit": { ru: "Подтвердить", en: "Confirm" },
  "admin.access.reason.cancel": { ru: "Отмена", en: "Cancel" },
  "admin.access.reason.pending": { ru: "Выполняется", en: "Working" },
  "admin.access.change.assign.title": {
    ru: "Назначить роль",
    en: "Assign role",
  },
  "admin.access.change.assign.summary": {
    ru: "Роль «{role}» будет назначена оператору {operator}.",
    en: 'Role "{role}" will be assigned to {operator}.',
  },
  "admin.access.change.assign.warning": {
    ru: "Оператор сразу получит все права этой роли. Действие записывается в журнал аудита.",
    en: "The operator gets every permission of this role at once. The action is written to the audit log.",
  },
  "admin.access.change.unassign.title": { ru: "Снять роль", en: "Remove role" },
  "admin.access.change.unassign.summary": {
    ru: "Роль «{role}» будет снята у оператора {operator}.",
    en: 'Role "{role}" will be removed from {operator}.',
  },
  "admin.access.change.unassign.warning": {
    ru: "Оператор сразу потеряет права этой роли. Если это последний администратор платформы, сервер откажет.",
    en: "The operator loses this role's permissions at once. The server refuses to remove the last platform administrator.",
  },
  "admin.access.change.deactivate.title": {
    ru: "Отключить оператора",
    en: "Deactivate operator",
  },
  "admin.access.change.deactivate.summary": {
    ru: "Оператор {operator} будет отключён.",
    en: "{operator} will be deactivated.",
  },
  "admin.access.change.deactivate.warning": {
    ru: "Все его сессии завершатся, войти в консоль он больше не сможет, связь с пользователем будет отключена.",
    en: "All their sessions end, they can no longer sign in, and the user link is disabled.",
  },
  "admin.access.change.activate.title": {
    ru: "Включить оператора",
    en: "Reactivate operator",
  },
  "admin.access.change.activate.summary": {
    ru: "Оператор {operator} будет снова включён.",
    en: "{operator} will be reactivated.",
  },
  "admin.access.change.activate.warning": {
    ru: "Оператор снова сможет входить в консоль с правами своих ролей.",
    en: "The operator can sign in again with the permissions of their roles.",
  },
  "admin.access.change.create.title": {
    ru: "Добавить оператора",
    en: "Add operator",
  },
  "admin.access.change.create.warning": {
    ru: "Оператор сможет войти в консоль под этим Auth0-аккаунтом и сразу получит права выбранных ролей.",
    en: "The operator can sign in with this Auth0 account and gets the permissions of the chosen roles at once.",
  },
  "admin.access.add.subject": { ru: "Auth0 user_id", en: "Auth0 user_id" },
  "admin.access.add.subjectHelp": {
    ru: "Скопируйте user_id из Auth0, например auth0|abc123.",
    en: "Copy the user_id from Auth0, for example auth0|abc123.",
  },
  "admin.access.add.displayName": { ru: "Имя", en: "Display name" },
  "admin.access.add.linkedUser": {
    ru: "ID пользователя Mioscape (необязательно)",
    en: "Mioscape user ID (optional)",
  },
  "admin.access.add.roles": { ru: "Роли", en: "Roles" },
  "admin.access.add.noRoles": {
    ru: "Нет ролей, которые вы можете назначить.",
    en: "No roles you can grant.",
  },
  "admin.access.add.error.subject": {
    ru: "Укажите user_id без пробелов, до 256 символов.",
    en: "Enter a user_id without spaces, up to 256 characters.",
  },
  "admin.access.add.error.displayName": {
    ru: "Имя обязательно, до 80 символов.",
    en: "A name is required, up to 80 characters.",
  },
  "admin.access.add.error.linkedUser": {
    ru: "ID пользователя должен быть в формате UUID.",
    en: "The user ID must be a UUID.",
  },
  "admin.access.stepUp.title": {
    ru: "Нужен свежий вход",
    en: "Fresh sign-in needed",
  },
  "admin.access.stepUp.body": {
    ru: "Изменение доступа требует свежего входа (не старше 10 минут). Войдите заново и повторите действие.",
    en: "Access changes need a fresh sign-in (at most 10 minutes old). Sign in again and repeat the action.",
  },
  "admin.access.stepUp.discarded": {
    ru: "Введённые данные не сохранятся.",
    en: "What you entered will not be kept.",
  },
  "admin.access.stepUp.action": {
    ru: "Войти заново для подтверждения",
    en: "Sign in again to confirm",
  },
  "admin.access.status.created": {
    ru: "Оператор добавлен.",
    en: "Operator added.",
  },
  "admin.access.status.updated": {
    ru: "Оператор обновлён.",
    en: "Operator updated.",
  },
  "admin.access.status.assigned": {
    ru: "Роль назначена.",
    en: "Role assigned.",
  },
  "admin.access.status.unassigned": { ru: "Роль снята.", en: "Role removed." },
  "admin.access.status.deactivated": {
    ru: "Оператор отключён.",
    en: "Operator deactivated.",
  },
  "admin.access.status.activated": {
    ru: "Оператор включён.",
    en: "Operator reactivated.",
  },
  "admin.access.status.unchanged": {
    ru: "Изменений нет: состояние уже такое.",
    en: "No change: the state was already like this.",
  },
  "admin.access.error.generic": {
    ru: "Не удалось выполнить изменение. Попробуйте ещё раз.",
    en: "The change failed. Try again.",
  },
  "admin.access.error.denied": {
    ru: "Недостаточно прав: у вашей роли нет права operators.manage.",
    en: "Not allowed: your role lacks operators.manage.",
  },
  "admin.access.error.invalid_identifier": {
    ru: "Некорректный идентификатор.",
    en: "Invalid identifier.",
  },
  "admin.access.error.reason_required": {
    ru: "Укажите комментарий (до 256 символов).",
    en: "Enter a comment (up to 256 characters).",
  },
  "admin.access.error.reason_code_invalid": {
    ru: "Выберите причину из списка.",
    en: "Pick a reason from the list.",
  },
  "admin.access.error.confirmation_required": {
    ru: "Подтвердите изменение.",
    en: "Confirm the change.",
  },
  "admin.access.error.subject_invalid": {
    ru: "Некорректный Auth0 user_id.",
    en: "Invalid Auth0 user_id.",
  },
  "admin.access.error.display_name_invalid": {
    ru: "Некорректное имя оператора.",
    en: "Invalid operator name.",
  },
  "admin.access.error.nothing_to_update": {
    ru: "Нечего обновлять.",
    en: "Nothing to update.",
  },
  "admin.access.error.role_escalation_denied": {
    ru: "Нельзя менять роль с правами, которых нет у вас.",
    en: "You cannot change a role holding permissions you lack.",
  },
  "admin.access.error.operator_not_found": {
    ru: "Оператор не найден.",
    en: "Operator not found.",
  },
  "admin.access.error.role_not_found": {
    ru: "Роль не найдена.",
    en: "Role not found.",
  },
  "admin.access.error.linked_user_not_found": {
    ru: "Связанный пользователь не найден.",
    en: "Linked user not found.",
  },
  "admin.access.error.operator_exists": {
    ru: "Оператор с таким Auth0 user_id уже есть.",
    en: "An operator with this Auth0 user_id already exists.",
  },
  "admin.access.error.operator_inactive": {
    ru: "Оператор отключён: сначала включите его.",
    en: "The operator is deactivated: reactivate first.",
  },
  "admin.access.error.role_inactive": {
    ru: "Роль отключена и не может быть назначена.",
    en: "The role is inactive and cannot be assigned.",
  },
  "admin.access.error.user_already_linked": {
    ru: "Этот пользователь уже связан с другим оператором.",
    en: "This user is already linked to another operator.",
  },
  "admin.access.error.last_platform_admin": {
    ru: "Это последний администратор платформы: изменение заблокировано.",
    en: "This is the last platform administrator: the change is blocked.",
  },
  "admin.access.error.cannot_deactivate_self": {
    ru: "Нельзя отключить самого себя.",
    en: "You cannot deactivate yourself.",
  },
  "admin.access.error.cannot_lock_out_self": {
    ru: "Нельзя снять роль, которая даёт вам право управлять операторами.",
    en: "You cannot remove the role that gives you operators.manage.",
  },
  "admin.access.error.too_many_roles": {
    ru: "Слишком много ролей: не больше 10.",
    en: "Too many roles: at most 10.",
  },
  "admin.access.error.step_up_required": {
    ru: "Нужен свежий вход (не старше 10 минут).",
    en: "A fresh sign-in is needed (at most 10 minutes old).",
  },
} as const;

export type AdminAccessMessageKey = keyof typeof adminAccessMessages;
